import { createAction } from "@reduxjs/toolkit";
import type { UpdateTeacherPublicProfileBody } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const updateTeacherPublicProfile = createApiThunk<void, UpdateTeacherPublicProfileBody>(
  "teachers/updateTeacherPublicProfile",
  async (body, { extra: { teacherRepository } }) => {
    return teacherRepository!.updatePublicProfile(body);
  },
);

export const resetUpdateTeacherPublicProfile = createAction("teachers/resetUpdateTeacherPublicProfile");
